import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { PuntoControlService } from './puntocontrol.service';
import { PuntoControlViewModel, AutoridadControlViewModel } from './puntocontrol.types';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { Tc } from '../../../core/_infrastructure/types/common';
import { Observable } from 'rxjs';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-puntocontrol-edit',
    templateUrl: './puntocontrol-edit.component.html',
})
export class PuntoControlEditComponent extends ComponentBase implements OnInit {
    editMode: boolean;
    editTitle: string = 'Nuevo';

    listPais: Tc[];

    puntoControl: PuntoControlViewModel;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        private puntoControlService: PuntoControlService,
        protected notificationService: NotificationService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
        this.puntoControl = new PuntoControlViewModel();
    }

    ngOnInit() {
        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.puntoControlService.getPuntoControl(id).subscribe(result => {
                this.puntoControl = result;
                this.updateForm();
            });
        }

        this.globalService.getPaisesUe().subscribe(res => {
            this.listPais = res;
        });
    }

    createForm() {
        this.form = this.fb.group({
            Descripcion: ['', Validators.required],
            IdPais: [null, Validators.required],
            IdentificadorTraces: ['', Validators.required],
            Direccion: ['', Validators.required],
            Localidad: ['', Validators.required],
            CodigoZip: ['', Validators.required],
            Activo: true,
        });
    }

    updateForm() {
        this.form.setValue({
            Descripcion: this.puntoControl.Descripcion,
            IdPais: this.puntoControl.IdPais,
            IdentificadorTraces: this.puntoControl.IdentificadorTraces,
            Direccion: this.puntoControl.Direccion,
            Localidad: this.puntoControl.Localidad,
            CodigoZip: this.puntoControl.CodigoZip,
            Activo: this.puntoControl.Activo,
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            return;
        }

        let puntoControl = new PuntoControlViewModel();

        puntoControl.Descripcion = this.form.value.Descripcion;
        puntoControl.IdPais = this.form.value.IdPais;
        puntoControl.IdentificadorTraces = this.form.value.IdentificadorTraces;
        puntoControl.Direccion = this.form.value.Direccion;
        puntoControl.Localidad = this.form.value.Localidad;
        puntoControl.CodigoZip = this.form.value.CodigoZip;
        puntoControl.Activo = this.form.value.Activo;

        puntoControl.Id = this.puntoControl.Id;

        if (this.editMode) {
            this.puntoControlService.editPuntoControl(puntoControl).subscribe({
                next: () => {
                    this.addSuccessMessage('Punto de Control modificado correctamente');
                    this.onBack();
                },
                error: error => this.catchServerError(error),
            });
        } else {
            this.puntoControlService.createPuntoControl(puntoControl).subscribe({
                next: () => {
                    this.addSuccessMessage('Punto de Control añadido correctamente');
                    this.onBack();
                },
                error: error => this.catchServerError(error),
            });
        }
    }

    onAddAutoridadControl() {
        this.router.navigate([this.router.url, 'autoridadcontrol', 'create']);
    }

    onEditAutoridadControl(item: AutoridadControlViewModel) {
        this.router.navigate([this.router.url, 'autoridadcontrol', 'edit', item.Id]);
    }

    onDeleteAutoridadControl(item: AutoridadControlViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.puntoControlService.deleteAutoridadControl(item.Id).subscribe({
                    next: () => {
                        this.addSuccessMessage('Autoridad de control eliminada correctamente');
                        const index = this.puntoControl.TwAutoridadControlCollection.findIndex(({ Id }) => Id === item.Id);
                        this.puntoControl.TwAutoridadControlCollection = this.puntoControl.TwAutoridadControlCollection.filter((_, s) => s !== index);
                    },
                    error: error => this.addErrorMessage('Error al borrar la Autoridad de Control o ya utilizada y se marca como Activa a NO.'),
                });
            },
        });
    }

    onBack() {
        this.router.navigate(['/mantenimiento/general/puntoscontrol']);
    }
}
